import getConfig from '@bonnet/core/config';
import { join } from '@bonnet/core/pathname';
import constants from '../constants';
import { getBonnetReferenceConfiguration } from './bonnetReferenceConfiguration';
export default function getReferenceApiPath() {
  const config = getConfig();
  const bonnetReferenceConfiguration = getBonnetReferenceConfiguration();
  const basePath = bonnetReferenceConfiguration.customBasePath || config.assetPrefix || process.env.BASE_PATH;
  for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }
  return join(basePath, constants.REFERENCE_API, ...parts);
}